import { reduxStore } from 'reduxStore'

import { HistoryUpdate } from 'api/history'
import * as PoziUtils from 'api/utils'
import PoziDrawerTabInfo from 'drawer/tabs/info/info'
import ModelUpdateLayer from 'drawer/tabs/layers/utils/ModelUpdateLayer' // Update Legacy Model
import { setCurrentTarget } from 'map/actions'

// import { setLayerUnselected } from 'drawer/tabs/layers/actions'

/**
 * Layer control event handler.
 * Unselecting a layer from the layer control.
 */
export default function UnSelectLayer (titleid) {
  const app = PoziUtils.getApp()

  const layer = PoziUtils.getLayerFromTitleID(titleid)

  if (layer.selected) {
    console.debug('Layer unselected', titleid)

    layer.selected = false

    // Currently the redux action calls SelectLayer, where it should be the other way around
    // window.store.dispatch(setLayerUnselected(layer.titleid))

    PoziUtils.gtag({
      category: 'useraction',
      status: 'success',
      identifier: layer.title,
      action: 'Layer Unselect'
    })
  }

  PoziUtils.turnLayerOff(titleid)

  let linkedLayers
  if (layer.linkedLayers) {
    linkedLayers = layer.linkedLayers || []
    console.debug('Hide linked layers from select layer event.', linkedLayers)
    PoziUtils.linkedLayersToggle(linkedLayers, false)
  }

  HistoryUpdate()

  // layer.selected = false
  ModelUpdateLayer(layer)
  // window.store.dispatch(setLayerUnselected(layer.titleid))

  const reduxState = reduxStore.getState()

  const { currentTarget, currentTargetIntersectLayers } = reduxState

  if (!currentTarget) {
    return
  }

  // Clear current target if the unselected layer is the current target
  if (currentTarget.titleid === layer.titleid) {
    PoziDrawerTabInfo().clearState() // this will reset the current target
    PoziDrawerTabInfo().tabsMode() // this will show the guidance info in the info panel

    return
  }

  // If the unselected layer is in the current target children, re-run setCurrentTarget
  const layerIntersectsCurrentTarget = currentTargetIntersectLayers.some(intersectLayer => intersectLayer.titleid === layer.titleid)
  if (layerIntersectsCurrentTarget) {
    console.debug('UnSelectLayer - layer is intersect layer. Re-running setCurrentTarget', currentTarget.titleid)

    reduxStore.dispatch(setCurrentTarget(currentTarget))
  }
}
